import React, { useState } from "react";
import RotatingRisquiKey from "../login/RotatingRisquiKey";
import { useNavigate } from "react-router-dom";
import AuthService from "../services/auth.service";
import { useAppContext } from "../AppContext";

const OneConferenceFreeTrial = () => {
  const [rotation, setRotation] = useState(0);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [signedUp, setSignedUp] = useState(false);

  let navigate = useNavigate();

  const { currentUser } = useAppContext();

  // if logged in, log out first to set password
  if (currentUser) {
    AuthService.logout();
    navigate(0);
  }

  const onChangeEmail = (e) => {
      setRotationByEmailLength(e.target.value);
      setEmail(e.target.value);
  };

  const setRotationByEmailLength = (email) => {
      setRotation(Math.max(-15, 80 - email.length * 5));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      const response = await fetch('/api/requests/trial', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, specialEvent: true }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.msg || 'Please try again later');
      }

      setMessage("Thank you for signing up! Please check your email for further instructions.");
      setSignedUp(true);
    } catch (error) {
      setMessage(error.toString());
    } finally {
      setLoading(false);
    }
  };

  return (
    <div id="login-container">
      <div className="container">
        <div className="col-md-12">
          <div id="login-content">
            <div id="login-logo" className="pointer-class" onClick={() => window.location.href = "https://risqui.nl"}>
              <i className="icon-risui" />
              <RotatingRisquiKey rotation={rotation} />
            </div>

            <div className="card card-container">
              <div id="content-title-small">You&apos;re invited to try Risqui</div>
              <div>
                Thank you for visiting our booth. We are pleased to offer you a <b>90-day</b> complimentary trial of Risqui, with no obligations.<br />
                <br />
                To begin, please enter your email address below. We will send you detailed instructions on how to get started right away.<br />
                <br />
                We look forward to assisting you on your journey with Risqui.
              </div>
              <hr />

              {message && (
                <div className="form-group">
                  <div className={`alert ${message.includes("Thank you for signing up!") ? "alert-success" : "alert-danger"}`} role="alert">
                    {message}
                  </div>
                </div>
              )}
              
              {!signedUp && (
                <form onSubmit={handleFormSubmit}>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      placeholder="name@email.com"
                      value={email}
                      onChange={onChangeEmail}
                      onBlur={(e) => setRotationByEmailLength(e.target.value)}
                      onFocus={(e) => setRotationByEmailLength(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <button className="btn btn-outline-primary btn-block login-submit" disabled={loading}>
                      {loading && <span className="spinner-border spinner-border-sm" />}
                      <span>Start Trial</span>
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OneConferenceFreeTrial;